import { Card, Text, textVariants } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import ContactMethods from '../../../../../common/components/ContactMethods';
import CaretButtonWithDrawer from '../../common/CaretButtonWithDrawer';
import type { ChatType } from '../../../../../common/chat/models';
import type { SnowplowEventDataType } from '../../../models';

interface ContactUsDrawerButtonProps {
  chatType: ChatType;
  snowplow: SnowplowEventDataType;
}

const ContactUsDrawerButton = ({ chatType, snowplow }: ContactUsDrawerButtonProps) => {
  const { t } = useTranslation();
  return (
    <CaretButtonWithDrawer
      dataTestId="contact-us-button"
      drawerContent={
        <Card>
          <ContactMethods chatType={chatType} isCallExpanded />
        </Card>
      }
      drawerTitle={t('MyBookingsWelcomePage.Banner.ContactUs.Link.Text')}
      snowplow={{
        category: snowplow.category,
        label: snowplow.label,
        property: snowplow.property,
      }}
    >
      <Text variant={textVariants._16_BOLD}>
        {t('MyBookingsWelcomePage.Banner.ContactUs.Link.Text')}
      </Text>
    </CaretButtonWithDrawer>
  );
};

export default ContactUsDrawerButton;
